<template lang="pug">
  div
    div Help
</template>

<script>
export default {
  name: "Help"
};
</script>

<style lang="stylus" scoped></style>
